// Angular
import { Component, OnInit } from "@angular/core";
// Models
// import { Post } from './../../models/post';
// External
import { AngularFireDatabase } from "angularfire2/database";
import * as lodash from "lodash";
import { DatePipe } from "@angular/common";
import { ApiService } from "./../../services/api";

import { OAuthService } from "./../../services/o-auth";
import { Order } from "./../../models/order";
import { AngularFireAuth } from "angularfire2/auth";

@Component({
  templateUrl: "./orders.component.html",
})
export class OrdersComponent implements OnInit {
  public orders: any = [];
  public nextKey: any;
  public selectAll: boolean;

  public prevKeys: Array<any>;
  private offsetOffers: number;
  public date: any;
  public order = "orderTime";
  public reverse = true;
  public imageLoader = true;
  private shortOffers: Array<{ $value: string; $key: string }>;
  public filterargs: Order;
  constructor(
    private fireDatabase: AngularFireDatabase,
    private oAuthService: OAuthService,
    private apiService: ApiService,
    private fireAuth: AngularFireAuth
  ) {
    this.prevKeys = [];
    this.filterargs = new Order();
    this.offsetOffers = 20;
    this.selectAll = false;
  }
  ngOnInit() {
    this.initOffersList();
  }
  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }

    this.order = value;
  }

  initOffersList() {
    this.imageLoader = true;
    const club = this.oAuthService.getClub().cid;
    this.selectAll = false;
    const fireObject = this.fireDatabase
      .object(`/user-offers/${club}`)
      .subscribe((result) => {
        if (result) {
          this.orders = [];
          lodash.forEach(result, (item, key) => {
            if (item) {
              item.$key = key;
              this.fireDatabase
                .object(`/offer-orders/${key}`)
                .subscribe((order) => {
                  if (order) {
                    lodash.forEach(order, (item1, key1) => {
                      if (item1) {
                        if (item1.payment) {
                          if (item1.payment.paymentStatus) {
                            item1.key = key1;
                            this.fireDatabase
                              .object(`users/${item1.uid}`)
                              .subscribe((user) => {
                                item1.user = user;
                                this.orders.push(item1);
                              });
                          }
                        }
                      }
                    });
                  }
                });
            }
          });
        }
      });

    this.imageLoader = false;
  }

  public redeem(offer) {
    if (confirm("Are you sure? you want to redeem this order")) {
      this.apiService.set(
        "/offer-orders/" + offer.offerId + "/" + offer.key + "/status",
        2
      );
      location.reload();
    }
  }
}
